import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';
import Color from 'color';

import { createUseThemedStyles } from '@/hooks';
import { ReactComponent as HackettLogo } from '@/assets/logos/logo-hackett-connect-r-large.svg';

const useStyles = createUseThemedStyles((theme) => ({
	header: {
		height: 60,
		display: 'flex',
		padding: '0 10px',
		alignItems: 'center',
		backgroundColor: theme.colors.primary,
		backgroundImage: `linear-gradient(-45deg, ${Color(theme.colors.primary)
			.darken(0.4)
			.hex()} 0%, ${Color(theme.colors.primary)
			.lighten(0.2)
			.desaturate(0.2)
			.hex()} 100%)`,
	},
}));

interface HeaderStandaloneProps {
	backTo?: string;
}

export const HeaderStandalone = ({ backTo }: HeaderStandaloneProps) => {
	const classes = useStyles();
	const navigate = useNavigate();

	return (
		<header className={classes.header}>
			<Button
				variant="link text-white"
				className="p-2 mr-2"
				onClick={() => {
					if (backTo) {
						navigate(backTo);
						return;
					}
					navigate(-1);
				}}
			>
				<ArrowLeft className="d-flex" width={20} height={20} />
			</Button>
			<Link to="/">
				<HackettLogo className="d-flex text-white" width={240} height={22} />
			</Link>
		</header>
	);
};
